// extracted by mini-css-extract-plugin
module.exports = {"root":"Title_root__1iRy7","h1":"Title_h1__1_fYG","h2":"Title_h2__S34LT","h3":"Title_h3__12Ycc"};